import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotepadText = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-notepad-text-icon lucide-notepad-text",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M8 2v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 2v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 2v4" }),
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 18,
			x: 4,
			y: 4,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M8 10h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 14h8" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 18h5" })
	]
});
export default SvgNotepadText;
